module.exports = __webpack_public_path__ + "img/image_5.69285d71.png";